import type { Dispatch, SetStateAction } from 'react';
import { forwardRef } from 'react';

// Icon
import Icon from '@/components/base/Icon';
import type { InputProps } from '@/components/base/Input';
import Input from '@/components/base/Input';

export type SingleDatepickerInputProps = InputProps & {
    toggleDatepicker?: () => Promise<void>;
    setReferenceElement?: Dispatch<SetStateAction<HTMLButtonElement>>;
    icon?: string;
};

const SingleDatepickerInput = forwardRef<HTMLInputElement, SingleDatepickerInputProps>(
    (
        { toggleDatepicker, setReferenceElement, icon = 'calendar', error, disabled, ...restProps },
        ref
    ) => {
        return (
            <button
                type="button"
                disabled={disabled}
                ref={setReferenceElement}
                className="w-full text-left focus-within:outline-none focus-within:ring-2 focus-within:ring-icoBlue-200 focus-within:ring-offset-0"
                onClick={toggleDatepicker}>
                <Input
                    ref={ref}
                    readOnly
                    className="cursor-pointer"
                    inputStyle="datepicker"
                    error={error}
                    beforeInput={
                        <div className="leading-none">
                            <Icon
                                icon={icon}
                                className="text-base text-icoGray-500 dark:text-icoDarkMode-wolf"
                            />
                        </div>
                    }
                    disabled={disabled}
                    {...restProps}
                />
            </button>
        );
    }
);

SingleDatepickerInput.displayName = 'DatepickerInput';

export default SingleDatepickerInput;
